'use client';

import { FooterNav } from '@petsmart-ui/sparky';
import './FooterSecondaryMenu.scss';
import type { Nullable } from '@libs/core';
import { dataLayerPush, layoutEvents } from '@libs/analytics';
import { getCurrentYear, PrivacyIcon } from '@libs/common-next';
import { ONETRUST_PRIVACY_OPTIONS_MODEL_CLASSNAME, PRIVACTY_OPTIONS_ICON_NAME } from '../../../constants';

const CURRENT_YEAR = getCurrentYear();

type flatLink = {
    actionText: string;
    sysId: string;
    webUrl: string;
    iconName?: string;
};

type FooterSecondaryMenuProps = {
    links: flatLink[];
    copyrightText: Nullable<string>;
};

export function FooterSecondaryMenu({ links, copyrightText }: FooterSecondaryMenuProps) {
    return (
        <div data-testid="footer-secondary-menu" className="footer__secondary-menu">
            <div className="copyright-section">{`© ${CURRENT_YEAR} ${copyrightText ?? ''}`}</div>
            <FooterNav className="secondary-navigation">
                {links.map(({ actionText, sysId, webUrl, iconName }) => {
                    // Cookie Privacy Options is a special link case
                    // It needs an icon, OneTrust integration and to avoid page reloads (via absence of href attribute)
                    const isPrivacyOptions = iconName === PRIVACTY_OPTIONS_ICON_NAME;

                    return isPrivacyOptions ? (
                        <FooterNav.Item
                            data-testid="onetrust-model-link"
                            linkClassName={ONETRUST_PRIVACY_OPTIONS_MODEL_CLASSNAME}
                            key={sysId}
                            text={
                                <>
                                    {actionText}
                                    <PrivacyIcon size={24} />
                                </>
                            }
                        />
                    ) : (
                        <FooterNav.Item
                            key={sysId}
                            href={webUrl}
                            text={actionText}
                            onClick={() =>
                                dataLayerPush({
                                    ...layoutEvents.footerClick,
                                    selection: actionText,
                                    link_url: webUrl,
                                })
                            }
                        />
                    );
                })}
            </FooterNav>
        </div>
    );
}
